import Vue from 'vue'
import Router from 'vue-router'
import jwt from "jsonwebtoken";

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/modules/users/Users')
const User = () => import('@/views/modules/users/User')
const UserCreate = () => import('@/views/modules/users/UserCreate')

//Agents
const NewRegistartion = () => import('@/views/modules/agents/agent_registration/NewRegistration')
const NewRegistrationDetail = () => import('@/views/modules/agents/agent_registration/NewRegistrationDetail')
const NewRegistrationEdit = () => import('@/views/modules/agents/agent_registration/NewRegistrationEdit')

const FollowUp = () => import('@/views/modules/agents/agent_registration/FollowUp')
const FollowUpDetail = () => import('@/views/modules/agents/agent_registration/FollowUpDetail')

const TopUp = () => import('@/views/modules/agents/agent_registration/TopUp')
const TopUpDetail = () => import('@/views/modules/agents/agent_registration/TopUpDetail')

const Listing = () => import('@/views/modules/agents/agent_registration/Listing')
const ListingDetail = () => import('@/views/modules/agents/agent_registration/ListingDetail')
const ListingAdjust = () => import('@/views/modules/agents/agent_registration/ListingAdjust')

const PrintDataAgent = () => import('@/views/modules/agents/agent_registration/PrintDataAgent')

//Agent - Location
const Location = () => import('@/views/modules/agents/locations/Location')
const Performance = () => import('@/views/modules/agents/reports/Report')
const Network = () => import('@/views/modules/agents/networks/Network')
const PosCreate = () => import('@/views/modules/agents/networks/POSCreate')
const PosDetail = () => import('@/views/modules/agents/networks/POSDetail')

//Programs
const Program = () => import('@/views/modules/programs/Program')
const ProgramCreate = () => import('@/views/modules/programs/ProgramCreate')
const ProgramEdit = () => import('@/views/modules/programs/ProgramEdit')

//FAQ
const faq = () => import('@/views/modules/faqs/Faq')
const faqCreate = () => import('@/views/modules/faqs/FaqCreate')
const faqEdit = () => import('@/views/modules/faqs/FaqEdit')

//Business Inquery
const BusinessInquiryRegistration = () => import('@/views/modules/business_inquiry/BusinessInquiryRegistration')
const BusinessInquiryListing = () => import('@/views/modules/business_inquiry/BusinessInquiryListing')
const RegistrationDetail = () => import('@/views/modules/business_inquiry/RegistrationDetail')
const ListingDetailBusiness = () => import('@/views/modules/business_inquiry/ListingDetail')
const ListingEditBusiness = () => import('@/views/modules/business_inquiry/ListingEdit')

//Career
const Division = () => import('@/views/modules/careers/division/Division')
const DivisionCreate = () => import('@/views/modules/careers/division/DivisionCreate')
const DivisionEdit = () => import('@/views/modules/careers/division/DivisionEdit')
const Job = () => import('@/views/modules/careers/jobs/Job')
const JobDetail = () => import('@/views/modules/careers/jobs/JobDetail')
const JobCreate = () => import('@/views/modules/careers/jobs/JobCreate')
const Applicant = () => import('@/views/modules/careers/applicants/Applicant')
const ApplicantDetail = () => import('@/views/modules/careers/applicants/ApplicantDetail')
const EmployeeBranding = () => import('@/views/modules/careers/employee_branding/EmployeeBranding.vue')
const EmployeeBrandingAdd = () => import('@/views/modules/careers/employee_branding/EmployeeBrandingAdd.vue')
const EmployeeBrandingEdit = () => import('@/views/modules/careers/employee_branding/EmployeeBrandingEdit.vue')

//About Us
const PressRelease = () => import('@/views/modules/about_us/press_release/PressRelease')
const PressReleaseCreate = () => import('@/views/modules/about_us/press_release/PressReleaseCreate')
const PressReleaseDetail = () => import('@/views/modules/about_us/press_release/PressReleaseDetail')
const PressReleaseEdit = () => import('@/views/modules/about_us/press_release/PressReleaseEdit')

//Corporate
const Corporate = () => import('@/views/modules/corporate/Corporate')
const CorporateCreate = () => import('@/views/modules/corporate/CorporateCreate')
const CorporateEdit = () => import('@/views/modules/corporate/CorporateEdit')

//Products
const Product = () => import('@/views/modules/products/Product')
const ProductServiceCreate = () => import('@/views/modules/products/ProductCreate')
const ProductServiceEdit = () => import('@/views/modules/products/ProductEdit')

//Member POS
const MemberPOS = () => import('@/views/modules/member_pos/MemberPOS')
const MemberPOSDetail = () => import('@/views/modules/member_pos/MemberPOSDetail')
const UsernamePOSDetail = () => import('@/views/modules/member_pos/UsernamePOSDetail')

// Banner
const Banner = () => import('@/views/modules/banners/Banner')

//Banner List
const BannerList = () => import('@/views/modules/banner_list/BannerList')
const BannerListCreate = () => import('@/views/modules/banner_list/BannerListCreate')
const BannerListEdit = () => import('@/views/modules/banner_list/BannerListEdit')

//Corporate Hashtag
const CorporateHashtag = () => import('@/views/modules/corporate_hashtag/CorporateHashtag')
const CorporateHashtagCreate = () => import('@/views/modules/corporate_hashtag/CorporateHashtagCreate')
const CorporateHashtagEdit = () => import('@/views/modules/corporate_hashtag/CorporateHashtagEdit')

//Meta Info
const MetaInfo = () => import('@/views/modules/meta_info/MetaInfo')
const MetaInfoCreate = () => import('@/views/modules/meta_info/MetaInfoCreate')
const MetaInfoEdit = () => import('@/views/modules/meta_info/MetaInfoEdit')

//Electronic Delivery Order
const EDOList = () => import('@/views/modules/e_do/EDOList')

function configRoutes() {
  return [

    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      meta:{
        auth:true,
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta:{
            auth:true,
          },
        },
        {
          path: 'management/account',
          redirect: '/management/account/list',
          name: 'Account',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'list',
              name: 'Account List',
              component: Users,
              meta:{
                auth:true,
              },
            },
            {
              path: 'create',
              meta: {
                label: 'Account Create Form',
                auth:true,
              },
              name: 'Account Create Form',
              component: UserCreate
            },
            {
              path: ':id',
              meta: {
                label: 'Account Details',
                auth:true,
              },
              name: 'Account Details',
              component: User
            }
          ],
        },
        {
          path: 'agent',
          redirect: '/agent/new-registration',
          name: 'Agent',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'new-registration',
              name: 'New Registartion',
              component: NewRegistartion,
              meta:{
                auth:true,
              },
            },
            {
              path: 'follow-up',
              name: 'Follow Up',
              component: FollowUp,
              meta:{
                auth:true,
              },
            },
            {
              path: 'top-up',
              name: 'Top Up',
              component: TopUp,
              meta:{
                auth:true,
              },
            },
            {
              path: 'listing',
              name: 'Listing',
              component: Listing,
              meta:{
                auth:true,
              },
            },
            {
              path: 'location',
              name: 'Location',
              component: Location,
              meta:{
                auth:true,
              },
            },
            {
              path: 'performance',
              name: 'Report Performance',
              component: Performance,
              meta:{
                auth:true,
              },
            },
            {
              path: 'network',
              name: 'Network',
              component: Network,
              meta:{
                auth:true,
              },
            },
            {
              path: 'network/pos/create',
              name: 'Create New POS',
              component: PosCreate,
              meta:{
                auth:true,
              },
            },
            {
              path: 'network/pos/detail/:id',
              name: 'Detail POS',
              component: PosDetail,
              meta:{
                auth:true,
              },
            },
            {
              path: 'new-registration/edit/:id',
              name: 'Edit Lampiran',
              component: NewRegistrationEdit,
              meta:{
                auth:true,
              },
            },
            {
              path: 'new-registration/:id',
              meta: {
                label: 'New Registration Detail',
                auth:true,
              },
              name: 'New Registration Detail',
              component: NewRegistrationDetail
            },
            {
              path: 'listing/:id',
              meta: {
                label: 'Listing Detail',
                auth:true,
              },
              name: 'Listing Detail',
              component: ListingDetail
            },
            {
              path: 'listing/adjust/:id',
              meta: {
                label: 'Ajust Pengajuan',
                auth:true,
              },
              name: 'Ajust Pengajuan',
              component: ListingAdjust
            },
            {
              path: 'follow-up/:id',
              meta: {
                label: 'Follow Up Detail',
                auth:true,
              },
              name: 'Follow Up Detail',
              component: FollowUpDetail
            },
            {
              path: 'top-up/:id',
              meta: {
                label: 'Top Up Detail',
                auth:true,
              },
              name: 'Top Up Detail',
              component: TopUpDetail
            },
          ],
        },
        {
          path: 'management/program',
          redirect: '/management/program/list',
          name: 'Program',

          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'list',
              name: 'Program List',
              component: Program,
              meta:{
                auth:true,
              },
            },
            {
              path: 'create',
              meta: {
                label: 'Program Create Form',
                auth:true,
              },
              name: 'Program Create Form',
              component: ProgramCreate
            },
            {
              path: ':id',
              meta: {
                label: 'Program Details',
                auth:true,
              },
              name: 'Program Details',
              component: ProgramEdit
            }
          ],
        },
        {
          path: 'management/faq',
          redirect: '/management/faq/list',
          name: 'FAQ',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'list',
              name: 'FAQ List',
              component: faq,
              meta:{
                auth:true,
              },
            },
            {
              path: 'create',
              meta: {
                label: 'FAQ Create Form',
                auth:true,
              },
              name: 'FAQ Create Form',
              component: faqCreate
            },
            {
              path: ':id',
              meta: {
                label: 'FAQ Edit Form',
                auth:true,
              },
              name: 'FAQ Edit Form',
              component: faqEdit
            }
          ],
        },
        {
          path: 'business_inquiry',
          redirect: 'business_inquiry/registration',
          name: 'Business Inquiry',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'registration',
              name: 'Pendaftaran',
              component: BusinessInquiryRegistration,
              meta:{
                auth:true,
              },
            },
            {
              path: 'listing',
              name: 'Business Inquiry Listing',
              component: BusinessInquiryListing,
              meta:{
                auth:true,
              },
            },
            {
              path: 'registration/:id',
              meta: {
                label: 'Detail Perusahaan',
                auth:true,
              },
              name: 'Detail Perusahaan',
              component: RegistrationDetail
            },
            {
              path: 'listing/edit/:id',
              meta: {
                label: 'Detail Perusahaan',
                auth:true,
              },
              name: 'Edit Perusahaan',
              component: ListingEditBusiness
            },
            {
              path: 'listing/detail/:id',
              meta: {
                label: 'Detail Perusahaan',
                auth:true,
              },
              name: 'Listing Detail Perusahaan',
              component: ListingDetailBusiness
            }
          ],
        },
        {
          path: 'career',
          redirect: '/career/job',
          name: 'Career',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'job',
              name: 'Job List',
              component: Job,
              meta:{
                auth:true,
              },
            },
            {
              path: 'division',
              name: 'Division List',
              component: Division,
              meta:{
                auth:true,
              },
            },
            {
              path: 'division/create',
              name: 'Division Create',
              component: DivisionCreate,
              meta:{
                auth:true,
              },
            },
            {
              path: 'division/:id',
              name: 'Division Edit',
              component: DivisionEdit,
              meta:{
                auth:true,
              },
            },
            {
              path: 'applicant',
              name: 'Applicant',
              component: Applicant,
              meta:{
                auth:true,
              },
            },
            {
              path: 'applicant/detail/:id',
              name: 'Applicant Detail',
              component: ApplicantDetail,
              meta:{
                auth:true,
              },
            },
            {
              path: 'job/detail/:id',
              name: 'Job Detail',
              component: JobDetail,
              meta:{
                auth:true,
              },
            },
            {
              path: 'job/create',
              name: 'Create Job',
              component: JobCreate,
              meta:{
                auth:true,
              },
            },
            {
              path: 'employee-branding',
              name: 'Employee Branding',
              component: EmployeeBranding,
              meta:{
                auth:true,
              },
            },
            {
              path: 'employee-branding/create',
              name: 'Employee Branding Create Form',
              component: EmployeeBrandingAdd,
              meta:{
                auth:true,
              },
            },
            {
              path: 'employee-branding/:id',
              name: 'Employee Branding Edit Form',
              component: EmployeeBrandingEdit,
              meta:{
                auth:true,
              },
            },
          ],
        },
        {
          path: 'about-us',
          redirect: '/about-us/press-release',
          name: 'About Us',

          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'press-release',
              name: 'Press Release',
              component: PressRelease,
              meta:{
                auth:true,
              },
            },
            {
              path: 'press-release/create',
              name: 'Press Release Create Form',
              component: PressReleaseCreate,
              meta:{
                auth:true,
              },
            },
            {
              path: 'press-release/detail/:id',
              name: 'Press Release Detail',
              component: PressReleaseDetail,
              meta:{
                auth:true,
              },
            },
            {
              path: 'press-release/edit/:id',
              name: 'Press Release Edit',
              component: PressReleaseEdit,
              meta:{
                auth:true,
              },
            },
          ],
        },
        {
          path: 'management/corporate',
          redirect: '/management/corporate/list',
          name: 'Corporate',

          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'list',
              name: 'Corporate List',
              component: Corporate,
              meta:{
                auth:true,
              },
            },
            {
              path: 'create',
              meta: {
                label: 'Corporate Create Form',
                auth:true,
              },
              name: 'Corporate Create Form',
              component: CorporateCreate
            },
            {
              path: ':id',
              meta: {
                label: 'Corporate Details',
                auth:true,
              },
              name: 'Corporate Details',
              component: CorporateEdit
            }
          ],
        },
        {
          path: 'management/corporate-hashtag',
          redirect: '/management/corporate-hashtag/list',
          name: 'Corporate Hashtag',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'list',
              name: 'Corporate Hashtag List',
              component: CorporateHashtag,
              meta:{
                auth:true,
              },
            },
            {
              path: 'create',
              meta: {
                label: 'Corporate Hashtag Create Form',
                auth:true,
              },
              name: 'Corporate Hashtag Create Form',
              component: CorporateHashtagCreate
            },
            {
              path: ':id',
              meta: {
                label: 'Corporate Hashtag Details',
                auth:true,
              },
              name: 'Corporate Hashtag Details',
              component: CorporateHashtagEdit
            }
          ],
        },
        {
          path: 'management/product',
          redirect: '/management/product/list',
          name: 'Product',

          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'list',
              name: 'Product List',
              component: Product,
              meta:{
                auth:true,
              },
            },
            {
              path: 'create',
              meta: {
                label: 'Products Create Form',
                auth:true,
              },
              name: 'Products Create Form',
              component: ProductServiceCreate
            },
            {
              path: ':id',
              meta: {
                label: 'Product Details',
                auth:true,
              },
              name: 'Product Details',
              component: ProductServiceEdit
            }
          ],
        },
        {
          path: 'management/member-pos',
          redirect: '/management/member-pos/list',
          name: 'Member POS',

          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'list',
              name: 'Member POS List',
              component: MemberPOS,
              meta:{
                auth:true,
              },
            },
            {
              path: 'edit/:id',
              meta: {
                label: 'Member POS Edit Form',
                auth:true,
              },
              name: 'Member POS Edit Form',
              component: MemberPOSDetail
            },
            {
              path: 'detail/:id',
              meta: {
                label: 'Member POS Detail Form',
                auth:true,
              },
              name: 'Member POS Detail Form',
              component: MemberPOSDetail
            },
            {
              path: ':memberPOSID/username/detail/:usernamePOSID',
              meta: {
                label: 'Username POS Detail Form',
                auth:true,
              },
              name: 'Username POS Detail Form',
              component: UsernamePOSDetail
            },
            {
              path: ':memberPOSID/username/edit/:usernamePOSID',
              meta: {
                label: 'Username POS Edit Form',
                auth:true,
              },
              name: 'Username POS Edit Form',
              component: UsernamePOSDetail
            }
          ],
        },
        {
          path: '/management/banners',
          name: 'Homepage Banner',
          component: Banner,
          meta:{
            auth:true,
          },
        },
        {
          path: 'management/meta-info',
          redirect: '/management/meta-info/list',
          name: 'Meta Info',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'list',
              name: 'Meta Info List',
              component: MetaInfo,
              meta:{
                auth:true,
              },
            },
            {
              path: 'create',
              meta: {
                label: 'Meta Info Create Form',
                auth:true,
              },
              name: 'Meta Info Create Form',
              component: MetaInfoCreate
            },
            {
              path: ':id',
              meta: {
                label: 'Meta Info Details',
                auth:true,
              },
              name: 'Meta Info Details',
              component: MetaInfoEdit
            }
          ],
        },
        {
          path: 'management/banner-list',
          redirect: '/management/banner-list/list',
          name: 'Banners',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'list',
              name: 'Banner List',
              component: BannerList,
              meta:{
                auth:true,
              },
            },
            {
              path: 'create',
              meta: {
                label: 'Banner List Create',
                auth:true,
              },
              name: 'Banner List Create',
              component: BannerListCreate
            },
            {
              path: ':id',
              meta: {
                label: 'Banner List Edit',
                auth:true,
              },
              name: 'Banner List Edit',
              component: BannerListEdit
            }
          ],
        },

        {
          path: 'management/e-do',
          redirect: '/management/e-do/list',
          name: 'Electronic Delivery Order',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          meta:{
            auth:true,
          },
          children: [
            {
              path: 'list',
              name: 'List',
              component: EDOList,
              meta:{
                auth:true,
              },
            },
          ],
        },
      ]
    },
    {
      path: '/print/:id',
      component: PrintDataAgent,
      meta:{
        auth:true,
      },
    },
    {
      path: '*',
      component: Page404
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
}

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

router.beforeEach((to, from, next) => {
  function checkAuth() {
    const accessToken = jwt.decode(localStorage.getItem("token"));
    const result = accessToken
    return result
  }

  const isAuth = checkAuth();

  if (!isAuth && to.meta.auth) {
    next({
      path: '/pages/login'
    });
    return;
  }
  if (to.name === "Login Page" && isAuth) {
    next({
      path: '/dashboard'
    });
    return;
  }
  next();
})

export default router
